import React from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {Col, Table} from "antd";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import {userTypes} from "../../../../constants/constants";

export const UsersTab = ({subcompanyId}) => {
    const stores = useStore();

    const [usersLoading, users, _, __, refetch] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.companyStore.getSubcompanyUsers.bind(null, {
            subcompanyId
        })
    });

    return (
        <div>
            <Table loading={usersLoading} dataSource={users?.data?.users} rowKey="id">
                <Col
                    title="Adı"
                    dataIndex="fullName"
                    render={(fullName, record) => (
                        <Link to={`/users/${record?._id}`}>{fullName}</Link>
                    )}
                />
                <Col
                    title="Kullanıcı Adı"
                    dataIndex="username"
                    render={username => username || "-"}
                />
                <Col title="Telefon Numarası" dataIndex="phone" render={phone => phone || "-"} />
                <Col title="Email" dataIndex="email" render={email => email || "-"} />
                <Col
                    title="Kullanıcı Durumu"
                    dataIndex="disabled"
                    render={disabled => (disabled ? "Pasif" : "Aktif")}
                />
                <Col
                    title="Yetki"
                    dataIndex="role"
                    render={role => userTypes.find(type => type.value === role)?.name}
                />
            </Table>
        </div>
    );
};
